import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';

export const RightHandSideWrapper = ({ children }: { children: React.ReactNode }) => {
	return <Box xcss={rightHandSideStyles}>{children}</Box>;
};

const rightHandSideStyles = xcss({
	display: 'none',
	[media.above.sm]: {
		display: 'block',
	},
});
